import {
  mergeSx,
  TableRow as BaseTableRow,
  type TableRowProps as BaseTableRowProps,
  type TableCellProps as BaseTableCellProps,
} from '@shared/components';
import { deepMerge } from '@shared/utils';

import TableCell from './table-cell';

export interface TableRowProps extends Omit<BaseTableRowProps, 'children'> {
  children: BaseTableCellProps[];
  collapsible?: boolean;
  tableRow?: BaseTableRowProps;
  tableCell?: BaseTableCellProps;
}

export default function TableRow(props: Readonly<TableRowProps>) {
  const {
    id,
    children,
    sx,
    collapsible: isCollapsible = false,
    tableRow: tableRowProps = {},
    tableCell: tableCellProps = {},
    ...restProps
  } = props;

  const combinedBodyRowProps = {
    ...deepMerge(restProps, tableRowProps),
    sx: mergeSx(sx, tableRowProps.sx),
  };

  const tableCells = children.map(({ id: tableCellId, ...cellProps }, index) => (
    <TableCell
      id={tableCellId}
      key={tableCellId ?? `table-generator-cell-${index}`}
      {...cellProps}
      tableCell={tableCellProps}
    />
  ));

  // TODO: Replace TableRow by collapsible row
  if (isCollapsible) {
    return (
      <BaseTableRow id={id} {...combinedBodyRowProps}>
        {tableCells}
      </BaseTableRow>
    );
  }

  return (
    <BaseTableRow id={id} {...combinedBodyRowProps}>
      {tableCells}
    </BaseTableRow>
  );
}
